import React from 'react'
import { useNavigate } from 'react-router-dom'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import SendIcon from '@mui/icons-material/Send'

import {useCurrentUser} from '~/client/hooks/auth'
import CommandForm from '~/client/components/CommandForm'
import AvatarAndNameInputs from '~/client/components/AvatarAndNameInputs'

export default function QuickSignupForm({
  disabled = false,
  oneLine = false,
  returnTo,
}){
  const navigate = useNavigate()
  const currentUserQuery = useCurrentUser()
  const [email, setEmail] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [avatar, onAvatarChange] = React.useState('')
  const [name, onNameChange] = React.useState('')

  const [passwordRequired, setPasswordRequired] = React.useState(false)
  const [badPassword, setBadPassword] = React.useState(false)
  const [emailNotFound, setEmailNotFound] = React.useState(false)
  const [sentMagicLink, setSentMagicLink] = React.useState(false)
  const signingUp = email === emailNotFound
  const passwording = email === passwordRequired
  const submittable = !!(email && (!passwordRequired || password))

  const onSubmit = React.useCallback(
    ({ sendMagicLink } = {}, command) => {
      command.call({
        email, password, avatar, name, returnTo, sendMagicLink
      })
    },
    [email, password, avatar, name, returnTo]
  )

  if (sentMagicLink) return <CheckYourEmail/>
  return <CommandForm {...{
    disabled,
    formButtons: false,
    command: signingUp ? 'users.signup' : 'users.login',
    submittable,
    submitText: 'Create Account',
    submittingText: 'Creating Account…',
    autoFocusSubmitButton: true,
    onSubmit,
    onSuccess(result){
      if (result.currentUser){
        currentUserQuery.mutate(result.currentUser)
        if (returnTo) navigate(returnTo)
      }
      else if (result.notFound) {
        setEmailNotFound(result.notFound.email)
      }
      else if (result.passwordRequired) {
        setPasswordRequired(result.passwordRequired.email)
      }
      else if (result.badPassword) {
        setBadPassword(true)
      }
      else if (result.sentMagicLink){
        setSentMagicLink(true)
      }
    },
  }}>{({ command, disabled, submitting }) =>
    <Stack
      direction={oneLine ? 'row' : 'column'}
      alignItems="center"
      spacing={2}
    >
      <TextField
        disabled={disabled}
        autoFocus={!passwordRequired}
        label="Email address"
        placeholder="you@example.com"
        autoComplete="email"
        margin="normal"
        fullWidth
        name="email"
        type="email"
        value={email}
        onChange={e => {
          setEmail(e.target.value)
          setPasswordRequired(false)
        }}
        inputProps={{
          sx: {backgroundColor: 'background.default'}
        }}
      />
      {signingUp
        ? <AvatarAndNameInputs {...{
          disabled,
          avatar,
          onAvatarChange,
          name,
          onNameChange,
          autoFocusName: true,
          sx: {width: '100%',}
        }}/>
        : null
      }
      {(passwording || signingUp)
        ? <TextField
          label="password"
          autoComplete="password"
          disabled={disabled}
          autoFocus={!!passwordRequired}
          margin="normal"
          fullWidth
          name="password"
          type="password"
          value={password}
          onChange={e => {
            setPassword(e.target.value)
            setBadPassword(false)
          }}
          error={!!badPassword}
          helperText={badPassword ? 'bad password' : ''}
        />
        : null
      }
      <Button
        type="submit"
        disabled={disabled || !submittable}
        variant="contained"
        color="success"
        fullWidth
      >{signingUp
        ? `Sign up`
        : `Sign in`
      }</Button>
      {passwording
        ? <Button
          disabled={disabled || !email}
          variant="contained"
          color="primary"
          fullWidth
          sx={{textAlign: 'center', position: 'relative'}}
          onClick={() => {
            onSubmit({ sendMagicLink: true }, command)
          }}
        >
          <SendIcon sx={{position: 'absolute', left: 8}}/>
          {submitting ? `Emailing…` : `Magic Link`}
        </Button>
        : null
      }
    </Stack>
  }</CommandForm>
}


function CheckYourEmail(){
  return <Stack direction="column" alignItems="center">
    <SendIcon sx={{
      fontSize: 'clamp(20vw, 200px, 30vw)',
      color: 'success.main'
    }}/>
    <Typography variant="h5">
      We've emailed you a link!
    </Typography>
    <Typography variant="h6" sx={{mt: 2}}>
      Please click that link to continue.
    </Typography>
  </Stack>
}
